<template>
  <div>
    <div class="table-container">
      <table :class="`list ${compact ? 'compact' : ''}`">
        <tr v-if="!!$slots.header" class="header">
          <slot name="header"></slot>
        </tr>
        <slot></slot>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    compact: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.table-container {
  // overflow-x: auto;
  box-shadow: 0 2px 1px 0 rgba(0, 0, 0, 0.06), 0 0 0 1px rgba(0, 0, 0, 0.02);
  border-radius: 10px;
}

.list {
  // border: 1px solid var(--table-border-color);
  width: 100%;
  white-space: nowrap;

  &.compact {
    & > * {
      &:not(:first-child) {
        &:hover {
          background-color: var(--table-item-hover-bg);
          cursor: pointer;
          border-radius: 0;
        }
      }
    }
  }

  &:not(.compact) {
    & > * {
      &:hover {
        background-color: var(--table-item-hover-bg);
        cursor: pointer;
        border-radius: 0;
      }
    }
  }

  & > * {
    position: relative;
    display: table-row;

    & > * {
      padding: 12px;
    }

    & > td {
      position: relative;
      max-width: 0;
      &:last-of-type {
        padding-right: 75px;
        .arrow {
          display: block;
        }
      }
    }
  }

  .arrow {
    color: var(--color-cta-blue);
    position: absolute;
    right: 10px;
    display: none;
    top: 50%;
    transition: all .3s;
    transform: translateY(-50%);
    font-size: 30px;
  }

  .header {
    background-color: var(--table-header-bg);
    border-radius: 10px 10px 0 0;

    & > * {
      border-bottom: 1px solid var(--table-header-border-color);
      color: var(--color-font-semi);
      font-size: 16px;
      font-weight: 400;
      padding: 15px;

      &:not(.ta-c) {
        text-align: left;
      }

      &:last-child {
        padding-right: 75px;
      }

      &.sortable {
        span {
          position: relative;

          &:after {
            font-family: 'icomoon' !important;
            speak: never;
            font-style: normal;
            font-weight: normal;
            font-variant: normal;
            text-transform: none;
            line-height: 1;
            font-size: 10px;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            content: "\e916";
            opacity: 0;
            position: absolute;
            right: -16px;
            top: calc(50% - 5px);
            transition: transform .3s;
          }
        }
      }

      &:hover, &.sorting {
        cursor: pointer;

        span:after {
          opacity: 1,
        }
      }

      &.asc {
        span:after {
          transform: rotate(180deg);
        }
      }
    }
  }

  .t-c {
    text-align: center;
  }

  &.compact {
    background-color: white;
    border-radius: 10px;
    box-shadow: 0 6px 12px 0 rgb(0 0 0 / 4%), 0 2px 4px 0 rgb(0 0 0 / 4%);

    header {
      border-radius: 10px 10px 0 0;
    }
  }
}
</style>
